import nextSignleton from "../utils/nextSignleton";

const inMemoryStorage = value => ({
	write: newValue => {
		value = newValue; // eslint-disable-line no-param-reassign
	},
	read: () => value,
	clear: () => {
		value = undefined; // eslint-disable-line no-param-reassign
	},
});

export const BillingInfo = nextSignleton(() => inMemoryStorage());
export const PriceItem = nextSignleton(() => inMemoryStorage());
export const CancelSurvey = nextSignleton(() => inMemoryStorage());
